export const JIRA_BASE_URL = 'https://linearb.atlassian.net/browse'

export const FEATURE_REQUESTS_COLUMNS = [
  { title: 'Key', width: '7%', sortKey: 'key' },
  { title: 'Summary', width: '22%' },
  { title: 'Status', width: '8%', sortKey: 'status' },
  { title: 'Priority', width: '8%', sortKey: 'priority' },
  { title: 'Issue Type', width: '9%' },
  { title: 'Impact Type', width: '9%' },
  { title: 'Customer', width: '10%', sortKey: 'customer_prospect' },
  { title: 'Org ID', width: '7%' },
  { title: 'Assignee', width: '9%', sortKey: 'assignee' },
  { title: 'Created', width: '8%', sortKey: 'created_at' },
  { title: 'Actions', width: '3%' }
]

export const ORG_FEATURE_REQUESTS_COLUMNS = [
  { title: 'Key', width: '7%', sortKey: 'key' },
  { title: 'Summary', width: '22%' },
  { title: 'Status', width: '8%', sortKey: 'status' },
  { title: 'Priority', width: '8%', sortKey: 'priority' },
  { title: 'Issue Type', width: '10%' },
  { title: 'Impact Type', width: '10%' },
  { title: 'Customer', width: '10%', sortKey: 'customer_prospect' },
  { title: 'Assignee', width: '10%', sortKey: 'assignee' },
  { title: 'Created', width: '10%', sortKey: 'created_at' },
  { title: 'Actions', width: '5%' }
]

export const ALL_FILTER_VALUE = 'all'

export const STATUS_OPTIONS = [
  { value: ALL_FILTER_VALUE, label: 'All Statuses' },
  { value: 'New Request', label: 'New Request' },
  { value: 'Accepted', label: 'Accepted' },
  { value: 'Planned', label: 'Planned' },
  { value: 'May do', label: 'May do' }
]

export const PRIORITY_OPTIONS = [
  { value: ALL_FILTER_VALUE, label: 'All Priorities' },
  { value: 'Highest', label: 'Highest' },
  { value: 'High', label: 'High' },
  { value: 'Medium', label: 'Medium' },
  { value: 'Low', label: 'Low' }
]

export const IMPACT_TYPE_OPTIONS = [
  { value: ALL_FILTER_VALUE, label: 'All Impact Types' },
  { value: 'Deal Blocker', label: 'Deal Blocker' },
  { value: 'Renewal Blocker', label: 'Renewal Blocker' },
  { value: 'Can help get more customers', label: 'Can help get more customers' },
  { value: 'Nice to Have', label: 'Nice to Have' }
]

export const ISSUE_TYPE_OPTIONS = [
  { value: ALL_FILTER_VALUE, label: 'All Issue Types' },
  { value: 'Customer Feature Requests', label: 'Customer Feature Requests' },
  { value: 'Request for Enhancement', label: 'Request for Enhancement' },
  { value: 'Internal Idea', label: 'Internal Idea' },
  { value: 'Task', label: 'Task' }
]